import React, { useEffect } from "react";
import "./IM.css";

import IMHeroImg from "../../../Gallery/ServicesImages/IM/Im.png";
import Img1 from "../../../Gallery/ServicesImages/IM/img1.png";
import Img2 from "../../../Gallery/ServicesImages/IM/img2.png";
import Img3 from "../../../Gallery/ServicesImages/IM/img3.png";


function IM() {
  useEffect(() => {
    const elements = document.querySelectorAll(".fade_up");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add("show");
      });
    });
    elements.forEach((el) => observer.observe(el));
  }, []);

  return (
    <div className="im_wrapper">

      {/* HERO SECTION */}
      <section className="im_hero_section">
        <img src={IMHeroImg} alt="Injection Moulding" className="im_hero_img" />
        <div className="im_hero_overlay"></div>
      </section>

      {/* ABOUT INJECTION MOULDING */}
      <section className="im_info_section">

        <div className="im_title_block fade_up">
          <h2 className="im_title">What Is Injection Molding?</h2>
          <div className="im_title_line"></div>
        </div>

        <p className="im_info_text fade_up">
          Injection molding is a high-precision manufacturing process used to produce
          plastic components with consistent shape and excellent repeatability.
          During the process, molten polymer is injected into a mold where it cools
          and takes the final form. It is widely preferred for producing both simple
          and complex parts in medium to large quantities with reliable accuracy.
        </p>

        <div className="im_title_block fade_up" style={{ marginTop: "50px" }}>
          <h2 className="im_title">Custom Plastic Injection Molding Services</h2>
          <div className="im_title_line"></div>
        </div>

        <p className="im_info_text fade_up">
          Custom injection molding allows the creation of parts tailored to specific
          performance, geometry, and material requirements. From low-volume prototype
          runs to full-scale mass production, the process supports a wide range of
          polymers and design complexities. Mold sizes, tonnage capacity, and
          material selection can be optimized to suit the intended application.
        </p>

      </section>

      {/* SERVICES SECTION */}
      <section className="im_services_section">

        <div className="im_services_grid">

          <div className="im_service_card">
            <img src={Img1} alt="Custom Injection Molding" />
            <h3>Custom Injection Molding</h3>
            <p>
              Custom molds are designed to match exact part specifications,
              enabling consistent production with tight tolerances. Suitable for
              functional components, aesthetic housings, and technical enclosures.
            </p>
          </div>

          <div className="im_service_card">
            <img src={Img2} alt="Insert Molding" />
            <h3>Insert Molding</h3>
            <p>
              Insert molding combines plastic with metal or threaded inserts,
              creating strong, unified parts. This method eliminates secondary
              fastening and increases durability in mechanical assemblies.
            </p>
          </div>

          <div className="im_service_card">
            <img src={Img3} alt="Overmolding" />
            <h3>Overmolding</h3>
            <p>
              Overmolding bonds two materials together, such as a rigid base layer
              and a soft-touch outer layer. It improves grip, aesthetics, and
              functional performance for multi-material products.
            </p>
          </div>

        </div>

      </section>

      {/* CAPABILITIES */}
      <section className="im_capabilities_section">

        <div className="im_cap_title_block fade_up">
          <h2 className="im_cap_title">Injection Moulding Capabilities</h2>
          <div className="im_cap_line"></div>
        </div>

        <p className="im_cap_text fade_up">
          Injection molding systems support a broad range of part sizes, tooling
          options, and material choices. Modern machines provide precise control
          over temperature, pressure, and cycle timing, ensuring high-quality
          results. Capabilities include multi-cavity molding, thin-wall molding,
          insert molding, and overmolding. Dedicated quality checks and testing
          methods help maintain dimensional accuracy and performance standards.
        </p>

      </section>

      {/* MATERIALS */}
      <section className="im_materials_section">

        <div className="im_mat_title_block">
          <h2 className="im_mat_title">Materials Used In Injection Molding</h2>
          <div className="im_mat_underline"></div>
        </div>

        <div className="im_materials_grid">

          <div className="im_material_card">
            <h3>ABS</h3>
            <p>
              A strong and rigid thermoplastic commonly used in consumer products,
              enclosures, housings, and structural components requiring toughness.
            </p>
          </div>

          <div className="im_material_card">
            <h3>NYLON</h3>
            <p>
              Known for durability and resistance to wear, nylon is used in gears,
              automotive parts, and mechanical components exposed to friction.
            </p>
          </div>

          <div className="im_material_card">
            <h3>PC</h3>
            <p>
              A transparent, impact-resistant polymer ideal for lenses, safety
              equipment, lighting covers, and precision enclosures.
            </p>
          </div>

          <div className="im_material_card">
            <h3>PP</h3>
            <p>
              Lightweight and chemically resistant, polypropylene is suited for
              packaging, medical items, and everyday consumer products.
            </p>
          </div>

          <div className="im_material_card">
            <h3>PEEK</h3>
            <p>
              A high-performance polymer offering excellent thermal and chemical
              resistance. Ideal for engineering applications requiring stability
              under extreme conditions.
            </p>
          </div>

          <div className="im_material_card">
            <h3>PEI – ULTEM</h3>
            <p>
              A strong, flame-resistant material used in aerospace, medical, and
              electronic components that require strength at high temperatures.
            </p>
          </div>

        </div>

      </section>

      {/* ALLIED SERVICES */}
      <section className="allied_services_section">

        <div className="allied_title_wrap">
          <div className="allied_title_circle"></div>
          <h2 className="allied_title">Allied Services</h2>
        </div>

        <div className="allied_services_grid">

          <div className="allied_service_card">
            <h3>Hot Foiling</h3>
            <p>
              A decorative finishing method that applies metallic foil onto
              plastic surfaces, improving appearance and enhancing product branding.
            </p>
          </div>

          <div className="allied_service_card">
            <h3>Ultrasonic Welding</h3>
            <p>
              A joining process that fuses plastic components using high-frequency
              vibrations, creating clean and precise welds without adhesives.
            </p>
          </div>

          <div className="allied_service_card">
            <h3>Spray Painting</h3>
            <p>
              Provides smooth, uniform surface finishes with a wide selection
              of colors and textures, suitable for functional and aesthetic parts.
            </p>
          </div>

          <div className="allied_service_card">
            <h3>Assembly</h3>
            <p>
              Final part assembly, fitting, and integration of molded components
              into complete products, ensuring functionality and compatibility.
            </p>
          </div>

          <div className="allied_service_card">
            <h3>Screen Printing</h3>
            <p>
              A reliable marking and labeling technique used for adding graphics,
              logos, and text onto plastic parts with durable ink adhesion.
            </p>
          </div>

        </div>

      </section>

    </div>
  );
}

export default IM;
